import { useEffect, useState, useRef } from "react";
import styles from "./EmailVerification.module.css";

import { useNavigate, useLocation } from "react-router-dom";
import BackToLoginPageButton from "../../Components/BackToLoginPageButton/BackToLoginPageButton";

import { verifyEmail } from "../../Api/Backend/Auth";

// .../login/verify-email
function EmailVerification() {
    const location = useLocation();
    const navigate = useNavigate();

    const [isSending, setIsSending] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const hasVerifiedToken = useRef(false);

    const handleVerifyEmail = async (token) => {
        setIsSending(true);
        setErrorMessage(null);

        await verifyEmail({
            token: token,
            onSuccess: () => {
                setIsVerified(true);
                setIsSending(false);
            },
            onError: (error) => {
                setErrorMessage(error.message || "이메일 인증 중 오류가 발생했습니다.");
                setIsVerified(false);
                setIsSending(false);
            }
        });
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const t = params.get("token");

        if (!t) {
            navigate("/login", { replace: true });
            return;
        }

        if (!hasVerifiedToken.current) {
            hasVerifiedToken.current = true;
            handleVerifyEmail(t);
        }
    }, [location.search, navigate]);


    return (
        <div className={styles.emailVerification}>
            <img className={styles.acornIcon} src="/images/logo.svg" alt="에이콘 로고" />
            <div className={styles.title}>
                이메일 인증이
            </div>

            {isSending && (
                <div className={styles.loading}>
                    <span className={styles.dot}>.</span>
                    <span className={styles.dot}>.</span>
                    <span className={styles.dot}>.</span>
                </div>
            )}

            {isVerified && (
                <>
                    <div className={styles.description}>
                        이메일 인증이 완료되었습니다!<br />
                        로그인 페이지로 이동해주세요.
                    </div>
                    <BackToLoginPageButton />
                </>
            )}

            {errorMessage &&
                <div className={styles.errorMessage}>{errorMessage}</div>
            }
        </div>
    );
}

export default EmailVerification;